import React, { createContext, useContext, useState } from "react";

const ObservationsModalContext = createContext();

export const useObservationsModal = () => useContext(ObservationsModalContext);

export const ObservationsModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [cipId, setCipId] = useState(null);
  const [componentId, setComponentId] = useState(null);
  const [patientName, setPatientName] = useState(null);

  const showObservationsModal = (cip, compId, name = null) => {
    setCipId(cip);
    setComponentId(compId);
    setPatientName(name);
    setOpen(true);
  };

  const closeObservationsModal = () => {
    setOpen(false);
    setCipId(null);
    setComponentId(null);
    setPatientName(null);
  };

  return (
    <ObservationsModalContext.Provider
      value={{
        open,
        cipId,
        componentId,
        patientName,
        showObservationsModal,
        closeObservationsModal,
      }}
    >
      {children}
    </ObservationsModalContext.Provider>
  );
};
